import { useState } from 'react';

export function useAnimatedModal(durationMs = 300) {
    const [show, setShow] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const open = () => setShow(true);

    const close = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShow(false);
            setIsClosing(false);
        }, durationMs);
    };

    return { show, isClosing, open, close };
}
